module.exports = __webpack_public_path__ + "static/media/steak-emoji.cade3885.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/steak-emoji.png
// module id = 11
// module chunks = 0